<template>
  <template v-if="pageHomeContent.field_etr_hp_info_image_link">
    <a
      :href="pageHomeContent.field_etr_hp_info_image_link"
      :target="pageHomeContent.field_etr_hp_info_image_link_blank"
      :aria-label="pageHomeContent.field_etr_hp_info_image_link_blank == '_blank' ? '(Voir nouvelle fenêtre) En savoir plus sur ' + pageHomeContent.field_etr_hp_info_title : 'En savoir plus sur ' + pageHomeContent.field_etr_hp_info_title "

      class="img--wrapper internal-link"
    >
      <img
        :src="pageHomeContent.field_etr_hp_info_image.url"
        :alt="pageHomeContent.field_etr_hp_info_image.alt">
    </a>
  </template>
  <template v-else>
    <div
      class="img--wrapper">
      <img
        :src="pageHomeContent.field_etr_hp_info_image.url"
        :alt="pageHomeContent.field_etr_hp_info_image.alt">
    </div>
  </template>
</template>

<script>
export default {
  props: {
    pageHomeContent: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
